<script setup>
</script>

<template>
  <div class="flex flex-col h-full p-6 bg-n-slate-2">
    <div class="mb-6">
      <h1 class="text-2xl font-semibold text-n-slate-12">DP CODE</h1>
      <p class="text-sm text-n-slate-11 mt-1">
        DP Foods custom code & settings
      </p>
    </div>

    <div class="flex-1 rounded-xl bg-white border border-n-weak p-6">
      <p class="text-n-slate-11">
        DP CODE panel ready.
      </p>
    </div>
  </div>
</template>
